import { ADMIN_ACCESS } from '@/entities/admin/lib/adminAccessCodes'

const ACCESS_CODE_IMPLY = {
  [ADMIN_ACCESS.CATALOG]: ADMIN_ACCESS.CATALOG_EDIT,
  [ADMIN_ACCESS.RESTAURANTS]: ADMIN_ACCESS.RESTAURANTS_EDIT,
  [ADMIN_ACCESS.ORDERS]: ADMIN_ACCESS.ORDERS_DELIVERY_FEE,
}

export function adminHasAccessCode(accessCodes, code) {
  if (accessCodes == null) {
    return true
  }

  const required = String(code ?? '').trim()
  if (!required || !Array.isArray(accessCodes)) {
    return false
  }

  if (accessCodes.includes(required)) {
    return true
  }

  const impliedBy = ACCESS_CODE_IMPLY[required]
  return Boolean(impliedBy && accessCodes.includes(impliedBy))
}

export function adminHasAnyAccessCode(accessCodes, codes) {
  const list = Array.isArray(codes) ? codes : []
  if (!list.length) {
    return true
  }
  return list.some((code) => adminHasAccessCode(accessCodes, code))
}
